import { companyURL } from 'endpoints';
import fetch from '../utils/fetch';

class CompanySDK {

    getCompanies = () => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ companyURL }/graphql`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        query: 'query { companyList { id, name, primaryLogo, primaryColor, secondaryColor } }',
                        variables: null
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data.data.companyList );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };

    getCompany = ( companyId ) => {
        if ( companyId ) {
            return new Promise( ( resolve, reject ) => {
                fetch( `${ companyURL }/graphql`, {
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    body: JSON.stringify(
                        {
                            query: `query { company(id: "${ companyId }") { id, name, variableList { name, value }, countryList { name, iso3Code, active }, primaryColor, primaryLogo, identifierList } }`,
                            variables: null
                        }
                    )
                } )
                .then( ( res ) => {
                    if ( res.ok ) {
                        res.json().then( ( data ) => {
                            resolve( {
                                id: data.data.company.id,
                                name: data.data.company.name,
                                countries: data.data.company.countryList,
                                logo: data.data.company.primaryLogo,
                                primaryColor: data.data.company.primaryColor
                            } );
                        } );
                    } else {
                        res.json().then( ( data ) => {
                            reject( data.message );
                        } );
                    }
                } )
                .catch ( ( err ) => {
                    reject( err.message );
                } );
            } );
        }

    };

}

export default new CompanySDK();
